import React from 'react';
import { Instagram, Play, Eye } from 'lucide-react';

const INSTAGRAM_PROFILE = 'https://www.instagram.com/o2nails_hyd/';

// Real Instagram reel URLs (owner-provided). Update `views` with real
// numbers from Instagram Insights when convenient.
const reels = [
  {
    url: 'https://www.instagram.com/reel/CzouD-BJEqp/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/lg6loeon_496ce527-9189-487d-8a15-eacfa3dcaec7.JPG',
    caption: 'Wedding nail art · Masaba × Akshay',
    views: '71.3K',
  },
  {
    url: 'https://www.instagram.com/reel/Cy6b0mASS_U/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/9xggc953_1551dd33-7d2d-43c6-90ab-ab4f868a172b.JPG',
    caption: 'Sarath City Capital Mall · Studio tour',
    views: '55.1K',
  },
  {
    url: 'https://www.instagram.com/reel/CzWmJNUp6r1/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/vfqebwal_9034b436-7f8f-4ab0-9b54-e8494e6c0a6b.JPG',
    caption: 'Chrome mirror set · Fresh drop',
    views: '48.2K',
  },
  {
    url: 'https://www.instagram.com/reel/CzouD-BJEqp/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/eutr5k53_10bbfade-b8e2-46de-906e-c25e93f7ac70.JPG',
    caption: 'Nude nail art transformation',
    views: '39.4K',
  },
  {
    url: 'https://www.instagram.com/reel/Cy6b0mASS_U/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/dygum5wl_764cabcf-8e2b-4bd4-9525-d6cac77e2365.JPG',
    caption: 'Black × pink extensions',
    views: '44.8K',
  },
  {
    url: 'https://www.instagram.com/reel/CzWmJNUp6r1/',
    thumb: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/8008smb4_c902773f-8d3d-45d0-928c-bb08d3789f09.JPG',
    caption: 'Green × gold glitter ombre',
    views: '32.6K',
  },
];

const trackClick = (label) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'instagram_click', {
        event_category: 'engagement',
        event_label: label,
      });
    }
  } catch (e) {
    // ignore analytics failures
  }
};

const openLink = (url, label) => {
  trackClick(label);
  window.open(url, '_blank', 'noopener,noreferrer');
};

const InstagramReelsStrip = () => {
  return (
    <section className="reels-section" data-testid="instagram-reels-section">
      <div className="reels-container">
        <div className="reels-header">
          <div className="reels-badge">
            <Instagram className="reels-badge-icon" />
            <span>Latest on Instagram</span>
          </div>
          <h2 className="reels-title">Watch Our Reels</h2>
          <p className="reels-subtitle">
            Fresh sets, behind-the-scenes moments &amp; every trend, straight from our studio
          </p>
          <button
            type="button"
            onClick={() => openLink(INSTAGRAM_PROFILE, 'reels_handle_cta')}
            className="reels-handle-btn"
            data-testid="instagram-reels-handle-btn"
            aria-label="Open @o2nails_hyd on Instagram"
          >
            <Instagram className="reels-handle-icon" />
            <span>@o2nails_hyd</span>
          </button>
        </div>

        <div className="reels-scroller" data-testid="instagram-reels-scroller">
          {reels.map((reel, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => openLink(reel.url, `reel_card_${idx + 1}`)}
              className="reel-card"
              data-testid={`instagram-reel-card-${idx + 1}`}
              aria-label={`Open Instagram reel: ${reel.caption}`}
            >
              <div className="reel-thumb-wrapper">
                <img
                  src={reel.thumb}
                  alt={`O2 Nails Hyd Instagram reel — ${reel.caption}`}
                  className="reel-thumb"
                  loading="lazy"
                />
                <div className="reel-thumb-overlay" />
                <div className="reel-play-badge" aria-hidden="true">
                  <Play className="reel-play-icon" />
                </div>
                <div className="reel-stats reel-stats-single">
                  <span className="reel-stat">
                    <Eye className="reel-stat-icon" />
                    {reel.views} views
                  </span>
                </div>
              </div>
              <p className="reel-caption">{reel.caption}</p>
            </button>
          ))}
        </div>

        <div className="reels-footer-cta">
          <button
            type="button"
            onClick={() => openLink(INSTAGRAM_PROFILE, 'reels_follow_cta')}
            className="reels-follow-btn"
            data-testid="instagram-reels-follow-btn"
          >
            <Instagram className="reels-follow-icon" />
            <span>Follow &amp; Watch More Reels</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default InstagramReelsStrip;
